/* MONTHLYREPORT */
export const MONTHLYREPORT_LIST = 'MONTHLYREPORT_LIST';
export const MONTHLYREPORT_LIST_SUCCESS = 'MONTHLYREPORT_LIST_SUCCESS';
export const MONTHLYREPORT_LIST_FAILED = 'MONTHLYREPORT_LIST_FAILED';


